import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import { tooltipItems } from "../../../utils/tootItems";
import info from "../../../../resources/images/info.png";
const headerStyle = {
  marginBottom: -20,
  cursor: "pointer",
  fontSize: "10px",
};

const noAnswerStyle = {
  marginBottom: -20,
  fontSize: "10px",
};

const QuestionContainer = ({ children, support, margin, instanceId }) => {
  const [openTooltip, setOpenTooltip] = useState(null);
  const toggleTooltip = useCallback((id) => {
    setOpenTooltip((prev) => (prev === id ? null : id));
  }, []);

  return (
    <div>
      <div className="row mt-5 align-items-end">
        {instanceId === "fr" && (
          <div className="col-1 text-center">
            {/* {support && "Support Questions"} */}
          </div>
        )}
        <div className={instanceId === "fr" ? "col-11" : "col-12"}>
          <div className="row">
            <div className={margin ? "col-6 col-md-5" : "col-6 col-md-7"} />

            <div className="col-6 col-md-5 bg-light">
              {/* only for fr assessment */}
              {instanceId === "fr" && (
                <div style={{}} className={`text-center py-2`}>
                  Assessment
                </div>
              )}
              {instanceId === "hm" ? (
                <div className="row">
                  <div
                    className="col-2 bg-light text-center py-2"
                    style={{ marginBottom: -20 }}
                  >
                    Weak
                  </div>
                  <div
                    className="col-2 bg-light text-center py-2"
                    style={{ marginBottom: -20 }}
                  >
                    Basic
                  </div>
                  <div
                    className="col-2 bg-light text-center py-2"
                    style={{ marginBottom: -20 }}
                  >
                    Strong
                  </div>
                  <div
                    className="col-3 bg-light text-center py-2"
                    style={{ marginBottom: -20 }}
                  >
                    Excellent
                  </div>
                  <div
                    className="col-3 bg-light text-center py-2"
                    style={{ marginBottom: -20 }}
                  >
                    No Answer
                  </div>
                </div>
              ) : (
                <div className="row">
                  {tooltipItems.map((item) => (
                    <div
                      key={item.id}
                      id={`${instanceId}-${item.target}`}
                      className={`${item.col} bg-light text-center py-2`}
                      style={headerStyle}
                    >
                      {item.title} <br />
                      <img
                        style={{ maxWidth: 14, maxheight: 14 }}
                        alt="info"
                        src={info}
                      />
                    </div>
                  ))}

                  <div
                    className="col-3 bg-light text-center py-2"
                    style={noAnswerStyle}
                  >
                    Not Applicable
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {instanceId === "fr" &&
        tooltipItems.map((item) => (
          <Tooltip
            key={item.id}
            placement="bottom"
            target={`${instanceId}-${item.target}`}
            isOpen={openTooltip === item.id}
            toggle={() => toggleTooltip(item.id)}
            autohide={false}
          >
            <div style={{ textAlign: "left", maxWidth: "450px" }}>
              {item.content}
            </div>
          </Tooltip>
        ))}

      {children}
    </div>
  );
};

QuestionContainer.propTypes = {
  children: PropTypes.array,
  support: PropTypes.bool,
  margin: PropTypes.bool,
};

QuestionContainer.defaultProps = {
  children: [],
  support: false,
  margin: false,
};

export default React.memo(QuestionContainer);
